
const Top = (breakpoint) => {
  const StalkingIcon = function () {
    const $el = $('#js-watch');
    const $area = $('#js-area');
    let x;
    let y = 0;
    $(window).on('scroll', () => {
      if ($area.innerHeight() < ($(window).scrollTop() + y + 100)) {
        $el.css({
          "transform": "",
          "position": ``,
        }).addClass('is-static');
        y = 0;
        x = 0;
      }
    });
    $area.on('mousemove', event => {
      x = event.clientX;
      y = event.clientY;
      $el.css({
        "transform": `translate(${x}px,${y}px) translateX(-50vw) translateX(-50%) translateY(-80%)`,
        "color": 'red',
        "position": `fixed`,
        "transition": 'transform 0.3s ease-out',
      }).removeClass('is-static');
    });
    $area.on('mouseleave', () => {
      $el.css({
        "transform": "",
        "position": ``,
      }).addClass('is-static');

    });
  }
  $(window).on('load resize', () => {
    if (window.innerWidth > breakpoint) {
      StalkingIcon();
    }
  })

  let x;
  let line = 0;
  $(window).on('scroll', () => {
    if (window.innerWidth > breakpoint) {
      x = window.pageYOffset;
      if (x > line) {
        $('.c-header').addClass('has-bg');
      } else {
        $('.c-header').removeClass('has-bg');
      }
    }
  })
  $(window).on('load resize', () => {
    if (window.innerWidth > breakpoint) {
      line = $('#js-area').height();
    }
  })

  // Wtachボタンの大きさ
  const ratio = 0.180645;
  let layerHeight;
  const $el = $('#js-watch');
  function watchSizing() {
    if (window.innerWidth > breakpoint) {
      layerHeight = $('#js-area').height();

      $el.css({
        width: `${layerHeight * ratio}px`,
        height: `${layerHeight * ratio}px`,
      })
    }
    setTimeout(() => {
      layerHeight = $('#js-area').height();

      $el.css({
        width: `${layerHeight * ratio}px`,
        height: `${layerHeight * ratio}px`,
      })
    }, 100)
  }
  $(window).on('resize load', () => {
    watchSizing();
  });
}

export default Top;


// WEBPACK FOOTER //
// ./src/recruit/js/top.js